import React from 'react'

const SearchCuisineShimmer = () => {
  return (
    <div className='min-w-[96px] h-[136px] bg-[#eef0f5] rounded mr-3' />
  )
}

export default SearchCuisineShimmer